<template>
  <Teleport v-if="show" :to="teleportTo">
    <Toast v-bind="dataProps" :class="classList" @destroy="onClose">
      <slot />
    </Toast>
  </Teleport>
</template>

<script setup>
import { computed } from 'vue';
import Toast from '@atomic-ui/toast/ToastRenderer';

import { useAlerts } from '../composables/useAlerts';

const props = defineProps({
  productId: {
    type: Number, // uses product?.product?.id from xapi response, which is of type Number
    required: true,
  },
  alertProps: {
    type: Object,
    default: () => ({}),
  },
});

const onClose = computed(() => {
  if ('onClose' in props.alertProps) {
    return props.alertProps.onClose;
  }
  return () => {};
});

const { dataProps, teleportTo, classList, show } = useAlerts({ ...props, ...props.alertProps });
</script>
<style lang="scss" scoped>
.pdp-toast--absolute {
  position: absolute;
}
</style>
